module.exports = __webpack_public_path__ + "static/img/index-pro-成本管理.4d293e36.png";